import { useEffect } from "react";

export const NotFoundPage = () => {

  return (
    <div className="m-2 text-dark">
      404 NOT FOUND
    </div>
  );
};
